import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import ReactNotify from 'react-notify';
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import MiejscowosciService from "./MiejscowosciService";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import KonfiguracjaHeader from "../../../../shared/headers/KonfiguracjaHeader";
import MiejscowosciForm from "./components/MiejscowosciForm";
import MiejscowosciTable from "./components/MiejscowosciTable";
import SzukajIPokazNaMapie from "./googleMapComponents/SzukajIPokazNaMapie";
import ScrollUtilities from "../../../../utilities/ScrollUtilities";

export default class MiejscowosciContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            miejscowosci: [],
            miejscowosc: null,
            pokazFormularz: false,
            wlaczSzukanie: true,
            pokazMape:false,
        };
        this.pobierzMiejscowosci = this.pobierzMiejscowosci.bind(this);
        this.pokazFormularz = this.pokazFormularz.bind(this);
        this.zamknijFormularz = this.zamknijFormularz.bind(this);
        this.onClickEdytuj = this.onClickEdytuj.bind(this);
        this.onClickUsun = this.onClickUsun.bind(this);
        this.onClickZapisz = this.onClickZapisz.bind(this);
        this.onClickPokazNaMapie = this.onClickPokazNaMapie.bind(this);
        this.onClickSzukajMiejscowosci = this.onClickSzukajMiejscowosci.bind(this);
        this.zamknijMape = this.zamknijMape.bind(this);
        this.zapiszWspolrzedneZMapy = this.zapiszWspolrzedneZMapy.bind(this)
    }

    componentDidMount() {
        this.pobierzMiejscowosci()
    }

    pobierzMiejscowosci() {
        MiejscowosciService.getMiejscowosci().then(function (response) {
            this.setState({miejscowosci: response.data.content})
        }.bind(this))
    }

    pokazFormularz() {
        this.setState({pokazFormularz: true})
        ScrollUtilities.scrollToTop()
    }

    zamknijFormularz() {
        this.setState({pokazFormularz: false, miejscowosc: null})
    }

    onClickEdytuj(obj) {
        this.pokazFormularz();
        this.setState({miejscowosc: obj})
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc miejscowość: ' + obj.nazMi)) {
            MiejscowosciService.deleteMiejscowosc(obj.idMi).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto miejscowość', "", 3000)
                    this.pobierzMiejscowosci();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania miejscowości', "", 3000)
                }
            }.bind(this))

        }
    }

    onClickZapisz(obj, czyEdycja) {

        if (czyEdycja) {
            MiejscowosciService.editMiejscowosc(this.state.miejscowosc.idMi, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie edytowano miejscowość', "", 3000)
                    this.pobierzMiejscowosci();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas edytowania miejscowości', "", 3000)
                }
            }.bind(this))

        }
        else {
            MiejscowosciService.addMiejscowosc(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie dodano miejscowość', "", 3000)
                    this.pobierzMiejscowosci();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania miejscowości', "", 3000)
                }
            }.bind(this))
        }

        this.zamknijFormularz();
    }

    onClickPokazNaMapie(obj) {
        this.setState({miejscowosc: obj,pokazMape:true})
    }

    onClickSzukajMiejscowosci(obj) {
        this.setState({miejscowosc: obj,pokazMape:true})
    }

    zamknijMape(){
        this.setState({miejscowosc:null,pokazMape:false})
    }

    zapiszWspolrzedneZMapy(lat,lng){
        let obj = this.state.miejscowosc;
        obj.szGps = lat
        obj.dlGps = lng

        MiejscowosciService.editMiejscowosc(this.state.miejscowosc.idMi,obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zapisano współrzedne', "", 3000)
                this.pobierzMiejscowosci();
                this.zamknijMape()
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas zapisu współrzędnych', "", 3000)
            }
        }.bind(this))


    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks} handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'MiejscowosciContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-trasami',
                                    text: 'Zarządzanie trasami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-trasami/miejscowosci', text: 'Miejscowości'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <TopIf isTrue={!Boolean(this.state.pokazFormularz) && !Boolean(this.state.pokazMape)}>
                                <KonfiguracjaHeader pokazFormularz={this.pokazFormularz}
                                                    tekstDodaj={'Dodaj miejscowość'}/*
                                                    pokazWyszukiwarke={this.onClickWlaczSzukanie}
                                                    czySzukanieWlaczone={this.state.wlaczSzukanie}*/
                                                    pokazButtonSzukaj={false}
                                />
                            </TopIf>
                            <TopIf isTrue={this.state.pokazMape}>
                                <div>
                                    {Boolean(this.state.miejscowosc) ?
                                        <SzukajIPokazNaMapie miejscowosc={this.state.miejscowosc}
                                                             handleZapiszWspolrzedneZMapy={this.zapiszWspolrzedneZMapy}
                                                             handleZamknijMape={this.zamknijMape}/>
                                        :
                                        ''
                                    }
                                </div>
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.pokazFormularz)}>
                                <MiejscowosciForm handleClickZapisz={this.onClickZapisz}
                                                  handleClickAnuluj={this.zamknijFormularz}
                                                  miejscowosc={this.state.miejscowosc}/>
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.miejscowosci)}>
                                <MiejscowosciTable data={this.state.miejscowosci}
                                                   wlaczSzukanie={this.state.wlaczSzukanie}
                                                   handleEdytuj={this.onClickEdytuj}
                                                   handleUsun={this.onClickUsun}
                                                   pokazNaMapie={this.onClickPokazNaMapie}
                                                   szukajMiejscowosci={this.onClickSzukajMiejscowosci}
                                                   czyJestWyswyetlonaMapa={this.state.pokazMape}
                                />
                            </TopIf>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/miejscowosci/MiejscowosciContainer.js